import React, { useState } from "react";
import { CircularProgress, Box } from "@mui/material";

const loadedImageUrls = new Set<string>();

interface MainImageProps {
  image: any;
  index: number;
}

const MainImage: React.FC<MainImageProps> = ({ image, index }) => {
  const [loaded, setLoaded] = useState(() => (typeof image === "string" ? loadedImageUrls.has(image) : false));
  const [errored, setErrored] = useState(false);

  React.useEffect(() => {
    setErrored(false);
    setLoaded(typeof image === "string" ? loadedImageUrls.has(image) : false);
  }, [image]);

  return (
    <Box
      data-tour="carousel-main-image"
      sx={{
        position: "relative",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: 5,
        overflow: "hidden",
        aspectRatio: 16 / 9,
        backgroundColor: "black",
      }}
    >
      {!loaded && !errored && (
        <CircularProgress
          size={40}
          sx={{ position: "absolute", zIndex: 2, color: "var(--ums-accent-red)" }}
        />
      )}

      {!errored ? (
        <img
          src={image}
          alt={`Carousel ${index}`}
          draggable="false"
          onLoad={() => {
            if (typeof image === "string") {
              loadedImageUrls.add(image);
            }
            setLoaded(true);
          }}
          onError={() => {
            setErrored(true);
            setLoaded(false);
          }}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
            objectPosition: "center",
            display: loaded ? "block" : "none",
          }}

        />
      ) : (
        <Box
          sx={{
            color: "#999",
            fontStyle: "italic",
            fontSize: "1rem",
            textAlign: "center",
          }}
        >
          Failed to load image
        </Box>
      )}
    </Box>
  );
};

export default MainImage;
